var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":'fm-poper-' + _vm.transition,"mode":"in-out"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"fm-poper",style:(_vm.poperStyle)},[_c('div',{class:{'fm-poper-init': _vm.init === false}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }